class CountrySelector extends HTMLElement {
    constructor() {
        super();
        // 简化为普通元素,不使用 Shadow DOM
        this.addEventListener('click', () => {
            // 获取弹窗元素并显示
            const dialog = document.querySelector('.ug-select-country-dialog');
            if (dialog) {
                dialog.style.display = 'block';
            }
        });

        // 添加关闭按钮事件
        document.querySelector('.ug-select-country-dialog__header__close__link')?.addEventListener('click', () => {
            const dialog = document.querySelector('.ug-select-country-dialog');
            if (dialog) {
                dialog.style.display = 'none';
            }
        });

        // this.initCountry();
    }

    initCountry() {
        const COUNTRY = {
            jp: "日本 / 日本語",
            eu: 'Europe / English',
            www: 'United States / English',
            ca: 'Canada / English',
            de: 'Deutschland / Deutsch',
            uk: 'United Kingdom / English',
            fr: 'France / Français',
            nl: 'Nederland / Nederlands',
        };

        const hostname = window.location.hostname;
        const country = hostname.split('.')[0];
        const currentCountry = COUNTRY[country] || 'United States / English';
        this.querySelector('.ug-current-country-text').textContent = currentCountry;
    }
}

customElements.define('ug-country-selector', CountrySelector);